import { useMutation } from '@tanstack/react-query';

import { setAuth } from '../app/consumerInfoSlice';
import { useAppDispatch } from '../app/hooks';
import { setNextStep } from '../app/loginSlice';
import { store } from '../app/store';
import { ApiRequestV2, httpRequestV2 } from './http/client';
import { Method } from './http/httpConsts';
import { LoginNextStep } from './login/login.api';

interface VerifyOtpRequest {
  requestId: string;
  code: string;
}

interface VerifyOtpResponse {
  requestID: string;
  nextStep: LoginNextStep;
  token: string;
  productUUID?: string;
}

interface VerifyOtpError {
  code: string;
  message?: string;
}

/**
 *
 * @param phone - non-numeric characters will be filtered before sending the request
 */
export const verifyOtp = async ({ requestId, code }: VerifyOtpRequest) => {
  const req: ApiRequestV2 = {
    path: '/v2/consumer/login/otp',
    method: Method.POST,
    body: {
      requestId,
      code,
    },
  };

  return httpRequestV2(req);
};

// TODO: should i move the below to a mutations folder?
interface VerifyOtpParams {
  code: string;
}

export const useVerifyOtp = () => {
  const dispatch = useAppDispatch();
  const auth = store.getState().consumerInfoSelector.auth;

  return useMutation<VerifyOtpResponse, VerifyOtpError, VerifyOtpParams>({
    mutationFn: (params) =>
      verifyOtp({ requestId: auth.requestID, code: params.code }),
    onSuccess: (data) => {
      dispatch(setNextStep(data.nextStep));
      dispatch(
        setAuth({ ...auth, token: data.token, requestID: data.requestID })
      );
    },
  });
};
